import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import Form from './Form.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../DoctorBite.js';
import PatientReviews from '../PatientReview.js';
import Counter from '../../NumCounter.js'
import GetInTouch from '../GetInTouch.js';
import FollowYt from '../FollowYt.js'
import Breadcrumb from '../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Intratympanic Steroid Injection in Delhi, India | Treatment, Cost, Doctor, Clinic</title>
            <meta name="description" content="Get safe Intratympanic Steroid Injection in Delhi, India for hearing loss or sudden deafness. Learn procedure, recovery, and cost at MedFirst ENT Centre." />
            <meta name="keywords" content="intratympanic injection Delhi, ear steroid treatment, sudden hearing loss cure, ENT ear therapy" />
            <link rel="canonical" href="https://entdelhi.com/intratympanic-steroid-injection/" />
            <meta property="og:title" content="Intratympanic Steroid Injection in Delhi, India | Treatment, Cost, Doctor, Clinic" />
            <meta property="og:description" content="Get safe Intratympanic Steroid Injection in Delhi, India for hearing loss or sudden deafness. Learn procedure, recovery, and cost at MedFirst ENT Centre." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
      <main>
        <Breadcrumb/>
        <Form />  
        <Counter/>
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}
